import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/business-directory/businesses/route-new")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: "Businesses",
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
